// Phase H Wave 2B · V12 Notifications Drawer · right-side feed audit.
// Phase H Wave 3B · FIX 30 · i18n cross-tenant access event label.
// V12 Achromatic Strict.
import React, { useEffect } from "react";
import { X } from "lucide-react";

import { useTranslation } from "@/i18n/I18nContext";

function _fmtTime(iso, locale = "it") {
    if (!iso) return "—";
    try {
        const d = new Date(iso);
        return d.toLocaleString(locale === "en" ? "en-GB" : "it-IT", {
            day: "2-digit", month: "short",
            hour: "2-digit", minute: "2-digit",
        });
    } catch { return iso; }
}

function _eventLabel(ev, t) {
    // FIX 30 · priorità alla traduzione i18n per cross-tenant access.
    if (ev === "super_admin_cross_tenant_access" && t) {
        const translated = t("dashboard.label.cross_tenant_access");
        if (translated && translated !== "dashboard.label.cross_tenant_access") {
            return translated;
        }
    }
    const map = {
        super_admin_cross_tenant_access: "Accesso cross-tenant super-admin",
        oauth_token_refreshed: "Refresh OAuth completato",
        oauth_token_refresh_failed: "Refresh OAuth fallito",
        oauth_refresh_cycle_run: "Ciclo refresh OAuth",
        fernet_key_rotation_completed: "Rotazione chiavi Fernet completata",
        fernet_key_rotation_dry_run: "Rotazione chiavi Fernet (prova)",
        social_credentials_v2_configured: "Credenziali social v2 configurate",
        social_credentials_v2_deleted: "Credenziali social v2 cancellate",
        social_deliverability_fetched: "Deliverability social raccolta",
        social_deliverability_cycle_run: "Ciclo deliverability social",
    };
    return map[ev] || ev || "Evento";
}

export default function V12NotificationsDrawer({ onClose, items = [] }) {
    const { t, locale } = useTranslation();
    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => { document.body.style.overflow = ""; };
    }, []);

    return (
        <div
            className="fixed inset-0 z-30 bg-black/50 backdrop-blur-sm flex justify-end"
            onClick={onClose}
            data-testid="v12-notif-overlay"
        >
            <aside
                className="w-full max-w-sm h-full bg-[#0D0D0D]
                           border-l border-[#1A1A1A] overflow-y-auto"
                onClick={(e) => e.stopPropagation()}
                data-testid="v12-notif-drawer"
            >
                <div className="sticky top-0 bg-[#0D0D0D] border-b border-[#1A1A1A]
                                px-4 py-3 flex items-center justify-between">
                    <h2 className="text-sm font-medium text-neutral-100">
                        {t("layout.notifications")}
                    </h2>
                    <button
                        type="button"
                        onClick={onClose}
                        className="text-neutral-500 hover:text-neutral-200"
                        aria-label={t("common.close")}
                        data-testid="v12-notif-close"
                    >
                        <X size={16} />
                    </button>
                </div>
                <ul className="divide-y divide-[#1A1A1A]">
                    {items.length === 0 && (
                        <li className="px-4 py-10 text-xs text-neutral-500 text-center"
                            data-testid="v12-notif-empty">
                            {t("common.empty")}
                        </li>
                    )}
                    {items.map((ev, i) => (
                        <li
                            key={`${ev.id || ev.timestamp || i}`}
                            className="px-4 py-3"
                            data-testid={`v12-notif-item-${i}`}
                        >
                            <div className="text-xs text-neutral-200">
                                {_eventLabel(ev.event_type, t)}
                            </div>
                            <div className="mt-1 text-[11px] text-neutral-500 flex gap-2">
                                <span>{_fmtTime(ev.timestamp, locale)}</span>
                                {ev.actor && (
                                    <>
                                        <span>·</span>
                                        <span className="truncate">{ev.actor}</span>
                                    </>
                                )}
                            </div>
                            {ev.channel && (
                                <div className="mt-1 text-[11px] text-neutral-500">
                                    {t("common.channel")}: <span className="text-neutral-400">{ev.channel}</span>
                                </div>
                            )}
                        </li>
                    ))}
                </ul>
            </aside>
        </div>
    );
}
